<!-- START: components/tabs -->
<app-alert></app-alert>
<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
        <a [routerLink]="['/']">Home</a>
    </li>
    <li>
        <a [routerLink]="['/KMP']">KMP</a>
    </li>
    <li id="breadCrumbAddKMPTitle">Add New KMP</li>
</ul>
<section class="card">
    <div class="card-header" *ngIf="environmentSettings.PSS">
        <span class="cat__core__title">
            <strong id="pageTitle">Add New KMP</strong>
        </span>
        <!-- <span style="float: right">
            <a routerLink="/KMP">
                <button class="btn btn-sm btn-default pull-right btn-back" type="button">
                    <i class=" fa fa-chevron-circle-left"></i>Back
                </button>
            </a>
        </span> -->
        <span style="float: right">
            <button class="btn btn-sm btn-primary" *ngIf="!directorIsAvailable && !isDirector" type="button"
                data-toggle="modal" data-target="#addAsKMP" (click)="addToDirector()">
                <i class="fa fa-plus-circle"></i>Add as Director</button>
            &nbsp;
            <button class="btn btn-sm btn-warning" *ngIf="isDirector" placement="left"
                ngbTooltip="After adding this Director, details will also be saved as KMP" triggers="click:blur">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Director</button>
            <!-- {{ directorIsAvailable}} -->
            <button class="btn btn-sm btn-success" *ngIf="directorIsAvailable" (click)="redirectKMPToDirector()"
                type="button" data-toggle="modal" data-target="#addAsKMP">
                <i class="fa fa-check-circle success-icon"></i> Director Master</button>
            <!-- <span class="badge badge-success">  <i class="fa fa-check-circle success-icon"></i> &nbsp; Added To KMP</span> -->
            &nbsp;
            <!-- <a routerLink="/KMP"> -->
                <button class="btn btn-sm btn-default pull-right btn-back" type="button" (click)="back()">
                    <i class=" fa fa-chevron-circle-left"></i>
                    Back
                </button>
            <!-- </a> -->
        </span>
    </div>
    <div class="card-header">
        <span class="cat__core__title">
            <strong id="pageTitle">Add New KMP</strong>
        </span>
        <span style="float: right">
            <!-- <a routerLink="/KMP"> -->
                <button class="btn btn-sm btn-default pull-right btn-back" type="button" (click)="back()">
                    <i class=" fa fa-chevron-circle-left"></i>
                    Back
                </button>
            <!-- </a> -->
        </span>
    </div>
    <div class="row">
        <div class="col-lg-12" id="kmpTabContainer">
            <ul class="nav nav-tabs" role="tablist">
                <!-- <li class="nav-item">
                    <a [ngClass]="[activeclassflag == true ? 'nav-link' : 'nav-link active']"  href="javascript: void(0);" data-toggle="tab" data-target="#personalDeatils" [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}" role="tab">Personal Details</a>

                </li>
                <li class="nav-item">
                    <a [ngClass]="[activeclassflag == true ? 'nav-link active' : 'nav-link']"  href="javascript: void(0);" data-toggle="tab" data-target="#professionalDetails" [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}" role="tab">Professional Details</a>

                </li> -->
                <li class="nav-item">
                    <a [ngClass]="[activeclassflag == true ? 'nav-link' : 'nav-link active']"
                        href="javascript: void(0);" data-toggle="tab" data-target="#personalDeatils"
                        [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                        role="tab">Personal Details</a>
                </li>
                <li class="nav-item">
                    <a [ngClass]="[activeclassflag == true ? 'nav-link active' : 'nav-link ']"
                        href="javascript: void(0);" data-toggle="tab" data-target="#professionalDetails"
                        [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                        role="tab">Professional Details</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#contactDetails"
                        [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                        role="tab">Contact Details</a>
                </li>
                <li class="nav-item" (click)="tabDisclosureOfInterestOnClickEvent();">
                    <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#officeOfKMP"
                        [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                        role="tab">Disclosure of Interest</a>
                </li>
                <li class="nav-item" (click)="tabSecurityHeldOnClickEvent();">
                    <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#detailsOfSecurities"
                        [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                        role="tab">Details of securities held</a>
                </li>
                <li class="nav-item" (click)="tabRelativeDetailsOnClickEvent();">
                    <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#relativedetails"
                        [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                        role="tab">Relatives' Details</a>
                </li>
            </ul>
            <div class="tab-content">
                <div [ngClass]="[activeclassflag == false ? 'tab-pane active' : 'tab-pane']" id="personalDeatils"
                    role="tabcard">
                    <!-- <h3>Personal Details Tab</h3> -->
                    <form [formGroup]='kmpPersonalForm' class="well" (document:click)="c.close();">
                        <div class="modal-body">

                            <section class="panel panel-default">
                                <div class="panel-heading">
                                    <h5 class="panel-title">Original Name</h5>
                                </div>
                                <div class="panel-body">
                                    <div class="row ">
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">First Name</label>
                                            <span _ngcontent-c2="" style="color: red;">*</span>
                                            <div class="form-group">
                                                <input id="firstNameFocus"
                                                    [formControl]="kmpPersonalForm.controls['FirstName']"
                                                    class="form-control" required="required">
                                                <div *ngIf="kmpPersonalForm.controls['FirstName'].hasError('pattern') && kmpPersonalForm.controls['FirstName'].touched"
                                                    class="form-control-error-custom">
                                                    First name is invalid.
                                                </div>
                                                <div *ngIf="kmpPersonalForm.controls['FirstName'].hasError('required') && kmpPersonalForm.controls['FirstName'].touched"
                                                    class="form-control-error-custom">
                                                    First name is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Middle Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['MiddleName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['MiddleName'].hasError('pattern') && kmpPersonalForm.controls['MiddleName'].touched"
                                                    class="form-control-error-custom">
                                                    Middle name is invalid.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Last Name</label>
                                            <span _ngcontent-c2="" style="color: red;">*</span>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['LastName']"
                                                    class="form-control" required="required">
                                                <div *ngIf="kmpPersonalForm.controls['LastName'].hasError('pattern') && kmpPersonalForm.controls['LastName'].touched"
                                                    class="form-control-error-custom">
                                                    Last name is invalid.
                                                </div>
                                                <div *ngIf="kmpPersonalForm.controls['LastName'].hasError('required') && kmpPersonalForm.controls['LastName'].touched"
                                                    class="form-control-error-custom">
                                                    Last name is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section class="panel panel-default">
                                <div class="panel-heading">
                                    <h5 class="panel-title">Father's Name</h5>
                                </div>
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">First Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['FatherFirstName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['FatherFirstName'].hasError('pattern') && kmpPersonalForm.controls['FatherFirstName'].touched"
                                                    class="form-control-error-custom">
                                                    Father first name is invalid.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Middle Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['FatherMiddleName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['FatherMiddleName'].hasError('pattern') && kmpPersonalForm.controls['FatherMiddleName'].touched"
                                                    class="form-control-error-custom">
                                                    Father middle name is invalid.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Last Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['FatherLastName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['FatherLastName'].hasError('pattern') && kmpPersonalForm.controls['FatherLastName'].touched"
                                                    class="form-control-error-custom">
                                                    Father last name is invalid.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section class="panel panel-default">
                                <div class="panel-heading">
                                    <h5 class="panel-title">Mother's Name</h5>
                                </div>
                                <div class="panel-body">
                                    <div class="row">

                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">First Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['MotherFirstName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['MotherFirstName'].hasError('pattern') && kmpPersonalForm.controls['MotherFirstName'].touched"
                                                    class="form-control-error-custom">
                                                    Mother first name is invalid.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Middle Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['MotherMiddleName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['MotherMiddleName'].hasError('pattern') && kmpPersonalForm.controls['MotherMiddleName'].touched"
                                                    class="form-control-error-custom">
                                                    Mother middle name is invalid.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Last Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['MotherLastName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['MotherLastName'].hasError('pattern') && kmpPersonalForm.controls['MotherLastName'].touched"
                                                    class="form-control-error-custom">
                                                    Mother last name is invalid.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Date Of Birth</label>
                                    <div class="input-group" (click)="$event.stopPropagation()">
                                        <input class="form-control" [maxDate]="TodayDate"
                                            [formControl]="kmpPersonalForm.controls['DateOfBirth']"
                                            [(ngModel)]="DateOfBirthModel" style="padding:6px;z-index: 0;"
                                            placeholder="dd-mm-yyyy" name="DateOfBirth" ngbDatepicker #c="ngbDatepicker"
                                            (click)="c.toggle()" (ngModelChange)="aboveEighteenYear()">
                                        <button class="input-group-addon" (click)="c.toggle()" type="button">
                                            <span class="fa fa-calendar"
                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                        </button>
                                    </div>
                                    <div *ngIf="!isDateOfBirthValid" class="form-control-error-custom">
                                        Date of Birth should not less than 18 years.
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Place Of Birth</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpPersonalForm.controls['BirthPlace']"
                                            class="form-control">
                                        <div *ngIf="kmpPersonalForm.controls['BirthPlace'].hasError('pattern') && kmpPersonalForm.controls['BirthPlace'].touched"
                                            class="form-control-error-custom">
                                            Birth place is invalid.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Gender</label>
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                    <div class="form-group">

                                        <div class="md-radio md-radio-inline" style="display: inline-block;margin-left:19px">
                                            <input id="genderMale" type="radio"
                                                [formControl]="kmpPersonalForm.controls['Gender']"
                                                style="position:absolute" name="Gender" value="Male"
                                                class="form-check-input" required="required">
                                            <label for="genderMale" style="padding: 0 29px 0px 0px">Male</label>
                                        </div>

                                        <div class="md-radio md-radio-inline" style="display: inline-block">
                                            <input id="genderFemale" type="radio"
                                                [formControl]="kmpPersonalForm.controls['Gender']"
                                                style="position:absolute" name="Gender" value="Female"
                                                class="form-check-input" required="required">
                                            <label for="genderFemale" style="padding: 0 29px 0px 0px">Female</label>
                                        </div>

                                        <div class="md-radio md-radio-inline" style="display: inline-block">
                                            <input id="genderTransgender" type="radio"
                                                [formControl]="kmpPersonalForm.controls['Gender']"
                                                style="position:absolute" name="Gender" value="Transgender"
                                                class="form-check-input" required="required">
                                            <label for="genderTransgender">Transgender</label>
                                        </div>
                                        <div *ngIf="kmpPersonalForm.controls['Gender'].hasError('required') && kmpPersonalForm.controls['Gender'].touched"
                                            class="form-control-error-custom">
                                            Gender is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Nationality</label>
                                    <div class="form-group">
                                        <select class="form-control"
                                            [formControl]="kmpPersonalForm.controls['Nationality']"
                                            style="padding:6px;">
                                            <option value="null" [selected]="true">Select</option>
                                            <option *ngFor="let country of countryList" [value]="country.Country">
                                                {{country.Country}}
                                            </option>

                                            <!-- <option value="Indian">Indian</option> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Resident</label>
                                    <div class="form-group">

                                        <div class="md-radio md-radio-inline" style="display: inline-block;margin-left:19px">
                                            <input id="residentYes" type="radio"
                                                [formControl]="kmpPersonalForm.controls['Resident']"
                                                style="position:absolute" name="Resident" value="true"
                                                class="form-check-input">
                                            <label for="residentYes" style="padding: 0 29px 0px 0px">Yes</label>
                                        </div>

                                        <div class="md-radio md-radio-inline" style="display: inline-block">
                                            <input id="residentNo" type="radio"
                                                [formControl]="kmpPersonalForm.controls['Resident']"
                                                style="position:absolute" name="Resident" value="false"
                                                class="form-check-input">
                                            <label for="residentNo">No</label>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Occupation</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpPersonalForm.controls['Occupation']"
                                            class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Educational Qualification</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpPersonalForm.controls['EducationalQualification']"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">PAN</label>
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                    <div class="form-group">
                                        <input [formControl]="kmpPersonalForm.controls['PAN']"
                                            class="form-control upperCase" required="required"
                                            pattern="^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$">
                                        <div *ngIf="kmpPersonalForm.controls['PAN'].hasError('pattern') && kmpPersonalForm.controls['PAN'].touched"
                                            class="form-control-error-custom">
                                            PAN is invalid.
                                        </div>
                                        <div *ngIf="kmpPersonalForm.controls['PAN'].hasError('required') && kmpPersonalForm.controls['PAN'].touched"
                                            class="form-control-error-custom">
                                            PAN is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Married</label>
                                    <div class="form-group">

                                        <div class="md-radio md-radio-inline" style="display: inline-block;margin-left:19px">
                                            <input id="marriedYes" type="radio"
                                                [formControl]="kmpPersonalForm.controls['IsMarried']"
                                                style="position:absolute" name="IsMarried" value="true"
                                                class="form-check-input" (click)='showMarridYesClick()'>
                                            <label for="marriedYes" style="padding: 0 29px 0px 0px">Yes</label>
                                        </div>

                                        <div class="md-radio md-radio-inline" style="display: inline-block">
                                            <input id="marriedNo" type="radio"
                                                [formControl]="kmpPersonalForm.controls['IsMarried']"
                                                style="position:absolute" name="IsMarried" value="false"
                                                class="form-check-input" (click)='hideMarridYesClick()'>
                                            <label for="marriedNo">No</label>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <section class="panel panel-default" *ngIf='showMarridYes'>
                                <div class="panel-heading">
                                    <h5 class="panel-title">Spouse Name</h5>
                                </div>
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">First Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['SpouseFirstName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['SpouseFirstName'].hasError('pattern') && kmpPersonalForm.controls['SpouseFirstName'].touched"
                                                    class="form-control-error-custom">
                                                    Spouse first name is invalid.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Middle Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['SpouseMiddleName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['SpouseMiddleName'].hasError('pattern') && kmpPersonalForm.controls['SpouseMiddleName'].touched"
                                                    class="form-control-error-custom">
                                                    Spouse middle name is invalid.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Last Name</label>
                                            <div class="form-group">
                                                <input [formControl]="kmpPersonalForm.controls['SpouseLastName']"
                                                    class="form-control">
                                                <div *ngIf="kmpPersonalForm.controls['SpouseLastName'].hasError('pattern') && kmpPersonalForm.controls['SpouseLastName'].touched"
                                                    class="form-control-error-custom">
                                                    Spouse last name is invalid.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Email ID</label>
                                    <!-- pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" -->
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                    <div class="form-group">
                                        <input [formControl]="kmpPersonalForm.controls['EmailID']"
                                            pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                                            class="form-control" required="required">
                                        <div *ngIf="kmpPersonalForm.controls['EmailID'].hasError('pattern')"
                                            class="form-control-error-custom">
                                            Email ID is not valid.
                                        </div>
                                        <div *ngIf="kmpPersonalForm.controls['EmailID'].hasError('required') && kmpPersonalForm.controls['EmailID'].touched"
                                            class="form-control-error-custom">
                                            Email ID is required.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby=""
                                aria-hidden="true" style="top: 50px;">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div id="alertTitle" class="modal-header"
                                            style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                            Title!
                                        </div>
                                        <div class="modal-body">
                                            <div id="alertMessage">
                                                Message..
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade" id="personalConfirmation" tabindex="-1" role="dialog"
                                aria-labelledby="" aria-hidden="true" style="top: 50px;">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="myModalLabelForDelete">
                                                <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    Are you sure you want to clear KMP personal details?
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-sm btn-danger"
                                                (click)="clearKmpPersonalDetails()">
                                                <i class="fa fa-check"></i>&nbsp;Yes
                                            </button>
                                            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                                                <i class="fa fa-times"></i>&nbsp;No
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="Submit" class="btn-sm btn btn-primary"
                                [disabled]="!(kmpPersonalForm.valid && isDateOfBirthValid)"
                                (click)="PersonalDetailsInsertUpdate()">
                                <span id="saveUpdateKMPPersonal"></span>
                            </button>
                            <button class="btn btn-sm btn-primary" (click)="generateOutput()" type="button">
                                <span>
                                    <i class="fa fa-save"></i>&nbsp;Generate Output
                                </span>
                            </button>
                            <button type="button" class="btn-sm btn btn-default" (click)="clearkmppersonalDetails()">
                                <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                        </div>
                    </form>
                </div>
                <!-- Tab 2 -->
                <div [ngClass]="[activeclassflag == true ? 'tab-pane active' : 'tab-pane']" id="professionalDetails"
                    role="tabcard">
                    <form [formGroup]="kmpProfessionalForm" class="well"
                        (document:click)="Af.close();ca.close();ta.close();ap.close();d.close();b.close();f.close();p.close();">
                        <div class="modal-body">

                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Designation</label>
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                    <div class="form-group">
                                        <select class="form-control"
                                            [formControl]="kmpProfessionalForm.controls['Designation']"
                                            style="padding:6px;" required="required"
                                            (change)="getDirector($event);getOtherDesignation($event);">
                                            <!-- <option value="" [selected]="true">Select Designation</option> -->
                                            <option value="" [selected]="true">Select</option>
                                            <option *ngFor="let designation of designationArray"
                                                [value]="designation.text">
                                                {{designation.text}}
                                            </option>
                                        </select>
                                        <div *ngIf="kmpProfessionalForm.controls['Designation'].hasError('required') && kmpProfessionalForm.controls['Designation'].touched"
                                            class="form-control-error-custom">
                                            Please select designation
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="selectDirector" class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Select Director</label>
                                    <div class="form-group">
                                        <select class="form-control" style="padding:6px;"
                                            [formControl]="kmpProfessionalForm.controls['DirectorID']"
                                            (change)="getInformationOfDirector(kmpProfessionalForm.controls['DirectorID'].value)">
                                            <option value="" [selected]="true">Select</option>
                                            <!-- <option value="" [selected]="true">Select Director</option> -->
                                            <option *ngFor="let director of directorArray" [value]="director._id">
                                                {{director.FirstName + " "+ director.LastName}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div *ngIf="showKmpOtherDesignation" class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Other Designation</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpProfessionalForm.controls['OtherDesignation']"
                                            class="form-control">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">DIN</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpProfessionalForm.controls['Din']" class="form-control"
                                            pattern="^([0-9]){8}?$" (keydown)="DinNumber($event)">
                                        <div *ngIf="kmpProfessionalForm.controls['Din'].hasError('pattern') && kmpProfessionalForm.controls['Din'].touched"
                                            class="form-control-error-custom">
                                            DIN is 8 digit number.
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Expertise in specific functional areas</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpProfessionalForm.controls['ExpertiseFunctionalAreas']"
                                            class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Date of board resolution in which the appointment
                                        was made as KMP</label>

                                    <div class="form-group">
                                        <div class="input-group" (click)="$event.stopPropagation()">
                                            <input class="form-control"
                                                [formControl]="kmpProfessionalForm.controls['BoardResolutionDate']"
                                                [(ngModel)]="BoardResolutionDateModel" style="padding:6px;"
                                                placeholder="dd-mm-yyyy" name="BoardDate" ngbDatepicker
                                                #b="ngbDatepicker"
                                                (click)="b.toggle();Af.close();ca.close();ta.close();ap.close();d.close();f.close();p.close();">
                                            <button class="input-group-addon"
                                                (click)="b.toggle();Af.close();ca.close();ta.close();ap.close();d.close();f.close();p.close();"
                                                type="button">
                                                <span class="fa fa-calendar"
                                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Appointment Date</label>
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                    <div class="form-group">
                                        <div class="input-group"
                                            (click)="$event.stopPropagation(); checkAppointmentDate();">
                                            <input class="form-control" [maxDate]="TodayDate"
                                                [formControl]="kmpProfessionalForm.controls['AppointmentDate']"
                                                [(ngModel)]="AppointmentDateModel" [minDate]="dateOfIncorpOfCompany"
                                                (ngModelChange)="setCessationAndReappointmentDate($event)"
                                                style="padding:6px;" placeholder="dd-mm-yyyy" name="AppointmentDate"
                                                ngbDatepicker #d="ngbDatepicker"
                                                (click)="d.toggle();Af.close();ca.close();ta.close();ap.close();b.close();f.close();p.close();checkAppointmentDate();"
                                                required="required">
                                            <button class="input-group-addon"
                                                (click)="d.toggle();Af.close();ca.close();ta.close();ap.close();b.close();f.close();p.close();checkAppointmentDate();"
                                                type="button">
                                                <span class="fa fa-calendar"
                                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                        </div>
                                        <div *ngIf="kmpProfessionalForm.controls['AppointmentDate'].hasError('required') && kmpProfessionalForm.controls['AppointmentDate'].touched"
                                            class="form-control-error-custom">
                                            Please select Appointment Date
                                        </div>
                                        <div *ngIf="disabledAppointmentDate" class="form-control-error-custom">
                                            Appointment date should not be less than date of Incorporation
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">E-Form DIR 12 filing date (for
                                        appointment)</label>
                                    <div class="form-group">
                                        <div class="input-group" (click)="$event.stopPropagation()">
                                            <input class="form-control"
                                                [formControl]="kmpProfessionalForm.controls['EformDIR12FilingDate']"
                                                [minDate]="FutureDIR12FillingDate" [maxDate]="TodayDate"
                                                [(ngModel)]="EformDIR12FilingDateModel" style="padding:6px;z-index: 0;"
                                                placeholder="dd-mm-yyyy"
                                                (ngModelChange)="DIR12FillingDateIsPriorToAppointmentDateInProfessional()"
                                                name="EformDIR12FilingDate" disabled="disabled" ngbDatepicker
                                                #ap="ngbDatepicker"
                                                (click)="ap.toggle();Af.close();ca.close();ta.close();d.close();b.close();f.close();p.close();"
                                                (click)="$event.stopPropagation()">
                                            <button class="input-group-addon"
                                                (click)="ap.toggle();Af.close();ca.close();ta.close();d.close();b.close();f.close();p.close();"
                                                type="button">
                                                <span class="fa fa-calendar"
                                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                        </div>
                                        <div *ngIf="IsDIR12FillingDatePriorInProfessional"
                                            class="form-control-error-custom">
                                            DIR12Filling date can not be prior to appointment date
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Date of filing MR 1</label>
                                    <div class="form-group">
                                        <div class="input-group" (click)="$event.stopPropagation()">
                                            <input class="form-control"
                                                [formControl]="kmpProfessionalForm.controls['FilingMR1Date']"
                                                [(ngModel)]="FilingMR1DateModel" style="padding:6px;z-index: 0;"
                                                placeholder="dd-mm-yyyy" name="FilingMR1Date" ngbDatepicker
                                                #f="ngbDatepicker"
                                                (click)="f.toggle();ap.close();Af.close();ca.close();ta.close();d.close();b.close();p.close();"
                                                (click)="$event.stopPropagation()">
                                            <button class="input-group-addon"
                                                (click)="f.toggle();ap.close();Af.close();ca.close();ta.close();d.close();b.close();p.close();"
                                                type="button">
                                                <span class="fa fa-calendar"
                                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Date of Re-appointment</label>
                                    <div class="form-group">
                                        <div class="input-group" (click)="$event.stopPropagation()">
                                            <input class="form-control" [minDate]="FutureReappointmentDate"
                                                [maxDate]="TodayDate"
                                                [formControl]="kmpProfessionalForm.controls['ReAppointmentDate']"
                                                [(ngModel)]="ReAppointmentDateModel" disabled="disabled"
                                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                                (ngModelChange)="ReappointmentDateIsPriorToAppointmentDateInProfessional();ReappointmentDateIsLaterToCessationDate();"
                                                name="ReAppointmentDate" ngbDatepicker #p="ngbDatepicker"
                                                (click)="p.toggle();ap.close();Af.close();ca.close();ta.close();d.close();b.close();f.close();">
                                            <button class="input-group-addon"
                                                (click)="p.toggle();ap.close();Af.close();ca.close();ta.close();d.close();b.close();f.close();"
                                                type="button">
                                                <span class="fa fa-calendar"
                                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                        </div>
                                        <div *ngIf="IsReappointmentDatePriorInProfessional"
                                            class="form-control-error-custom">
                                            Reappointment date can not be prior to appointment date
                                        </div>
                                        <div *ngIf="IsReappointmentDateLaterInProfessional"
                                            class="form-control-error-custom">
                                            Reappointment date can not be later to cessation date
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Date of filing MR 2</label>
                                    <div class="form-group">
                                        <div class="input-group" (click)="$event.stopPropagation()">
                                            <input class="form-control"
                                                [formControl]="kmpProfessionalForm.controls['FillingMR2Date']"
                                                [(ngModel)]="FillingMR2DateModel" style="padding:6px;z-index: 0;"
                                                placeholder="dd-mm-yyyy" name="FillingMR2Date" ngbDatepicker
                                                #Af="ngbDatepicker"
                                                (click)="Af.toggle();p.close();ap.close();ca.close();ta.close();d.close();b.close();f.close();">
                                            <button class="input-group-addon"
                                                (click)="Af.toggle();p.close();ap.close();ca.close();ta.close();d.close();b.close();f.close();"
                                                type="button">
                                                <span class="fa fa-calendar"
                                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Tenure</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpProfessionalForm.controls['Tenure']"
                                            class="form-control" placeholder="">
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Term of Appointment completion date</label>
                                    <div class="form-group">
                                        <div class="input-group" (click)="$event.stopPropagation()">
                                            <input class="form-control"
                                                [formControl]="kmpProfessionalForm.controls['AppointmentCompletionDate']"
                                                [(ngModel)]="AppointmentCompletionDateModel"
                                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                                name="AppointmentCompletionDate" ngbDatepicker #ta="ngbDatepicker"
                                                (click)="ta.toggle();Af.close();p.close();ap.close();Af.close();ca.close();d.close();b.close();">
                                            <button class="input-group-addon"
                                                (click)="ta.toggle();Af.close();p.close();ap.close();Af.close();ca.close();d.close();b.close();"
                                                type="button">
                                                <span class="fa fa-calendar"
                                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Cessation Date</label>
                                    <div class="form-group">
                                        <div class="input-group" (click)="$event.stopPropagation()">
                                            <input class="form-control"
                                                [formControl]="kmpProfessionalForm.controls['CessationDate']"
                                                [minDate]="FutureCessationDate" [maxDate]="TodayDate"
                                                [(ngModel)]="CessationDateModel" disabled="disabled"
                                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                                (ngModelChange)="CessationDateIsPriorToAppointmentDateInProfessional();ReappointmentDateIsLaterToCessationDate();"
                                                name="CessationDate" ngbDatepicker #ca="ngbDatepicker"
                                                (click)="ca.toggle();ta.close();Af.toggle();p.close();ap.close();Af.close();d.close();b.close();">
                                            <button class="input-group-addon"
                                                (click)="ca.toggle();ta.close();Af.toggle();p.close();ap.close();Af.close();d.close();b.close();"
                                                type="button">
                                                <span class="fa fa-calendar"
                                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                        </div>
                                        <div *ngIf="IsCessationDatePriorInProfessional"
                                            class="form-control-error-custom">
                                            Cessation date can not be prior to appointment date
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Membership Number</label>
                                    <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                                    <!-- pattern="^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$" -->
                                    <div class="form-group">
                                        <input [formControl]="kmpProfessionalForm.controls['MembershipNumber']"
                                            class="form-control" pattern="^[0-9a-zA-Z]+$">
                                        <!-- <div *ngIf="kmpProfessionalForm.controls['MembershipNumber'].hasError('required') && kmpProfessionalForm.controls['MembershipNumber'].touched"
                                            class="form-control-error-custom">
                                            Membership Number is required.
                                        </div> -->
                                        <div *ngIf="kmpProfessionalForm.controls['MembershipNumber'].hasError('pattern') && kmpProfessionalForm.controls['MembershipNumber'].touched"
                                            class="form-control-error-custom">
                                            Membership Number is invalid.
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Institute</label>
                                    <div class="form-group">
                                        <select class="form-control"
                                            [formControl]="kmpProfessionalForm.controls['Institute']"
                                            style="padding:6px;" (change)="otherInstitute($event)">
                                            <!-- <option value="null" [selected]="true">Select Institute</option> -->
                                            <option value="null" [selected]="true">Select</option>
                                            <option value="CA">CA</option>
                                            <option value="CFA">CFA</option>
                                            <option value="CFA">CS</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <div *ngIf="kmpProfessionalForm.controls['Institute'].hasError('required') && kmpProfessionalForm.controls['Institute'].touched"
                                            class="form-control-error-custom">
                                            Please select institute.
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="IsOtherInstitute" class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Other Institute</label>
                                    <div class="form-group">
                                        <input class="form-control"
                                            [formControl]="kmpProfessionalForm.controls['OtherInstitute']"
                                            class="form-control">
                                    </div>
                                </div>
                            </div>

                            <div class="modal fade" id="messagePopUp1" tabindex="-1" role="dialog" aria-labelledby=""
                                aria-hidden="true" style="top: 50px;">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div id="alertTitle1" class="modal-header"
                                            style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                            Title!
                                        </div>
                                        <div class="modal-body">
                                            <div id="alertMessage1">
                                                Message..
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade" id="professionalConfirmation" tabindex="-1" role="dialog"
                                aria-labelledby="" aria-hidden="true" style="top: 50px;">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="myModalLabelForDelete">
                                                <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    Are you sure you want to clear KMP professional details?
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-sm btn-danger"
                                                (click)="clearProfessionalDetails()">
                                                <i class="fa fa-check"></i>&nbsp;Yes
                                            </button>
                                            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                                                <i class="fa fa-times"></i>&nbsp;No
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="Submit" class="btn-sm btn btn-primary" [disabled]="!kmpProfessionalForm.valid"
                                (click)="professionalDetailsInsertUpdate()">
                                <span id="saveUpdateKMPProfessionalDetails"></span>
                            </button>
                            <button type="button" class="btn-sm btn btn-default"
                                (click)="clearkmpprofessionalDetails()">
                                <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                        </div>
                    </form>
                </div>

                <!-- Tab 3 -->
                <div class="tab-pane" id="contactDetails" role="tabcard">
                    <!-- <h3>Contact Details Tab</h3> kmpContactForm -->
                    <form [formGroup]="kmpContactForm" class="well">
                        <div class="modal-body">

                            <div class="row">
                                <div class="col-md-12">
                                    <section class="panel panel-default">
                                        <div class="panel-heading">
                                            <h5 class="panel-title">Permanent Residential Address</h5>
                                        </div>
                                        <div class="panel-body">
                                            <div formGroupName="PermenantResidentialAddress">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Line 1</label>
                                                        <div class="form-group">
                                                            <input formControlName="Line1" class="form-control">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Line 2</label>
                                                        <div class="form-group">
                                                            <input formControlName="Line2" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Country</label>
                                                        <div class="form-group">
                                                            <input formControlName="Country" class="form-control"
                                                                (keydown)="onlyAlphabates($event)">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">State</label>
                                                        <div class="form-group">
                                                            <input formControlName="State" class="form-control"
                                                                (keydown)="onlyAlphabates($event)">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">City</label>
                                                        <div class="form-group">
                                                            <input formControlName="City" class="form-control"
                                                                (keydown)="onlyAlphabates($event)">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Pin Code</label>
                                                        <div class="form-group">
                                                            <input formControlName="PinCode" class="form-control"
                                                                (keydown)="onlyNumber($event)">
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>

                            <div class="row">
                                <label class="form-control-label col-md-4">Whether Present Address is same as Permanent
                                    Address?</label>
                                <div class="col-md-8">
                                    <div class="form-group">

                                        <div class="md-radio md-radio-inline">
                                            <input id="presentAddressYes" type="radio" style="position:absolute"
                                                name="addresisssame" value="true" class="form-check-input"
                                                [formControl]="kmpContactForm.controls['isAddressSame']"
                                                (click)="presentaddressIssame()">
                                            <label for="presentAddressYes">Yes</label>
                                        </div>

                                        <div class="md-radio md-radio-inline">
                                            <input id="presentAddressNo" type="radio" style="position:absolute"
                                                name="addresisssame" value="false"
                                                [formControl]="kmpContactForm.controls['isAddressSame']"
                                                class="form-check-input" (click)="permenantaddressIsnotsame()">
                                            <label for="presentAddressNo">No</label>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">

                                    <section class="panel panel-default">
                                        <div class="panel-heading">
                                            <h5 class="panel-title">Present Residential Address</h5>
                                        </div>
                                        <div class="panel-body">
                                            <div formGroupName="PresentResidentialAddress">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Line 1</label>
                                                        <div class="form-group">
                                                            <input formControlName="Line1" class="form-control">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Line 2</label>
                                                        <div class="form-group">
                                                            <input formControlName="Line2" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="form-control-label">Country</label>
                                                            <!-- <select formControlName="Country" class="form-control select">
                                                                        <option value="null" [selected]="true">Select Country</option>
                                                                        <option value="India" selected="selected">India</option>
                                                                    </select> -->
                                                            <input formControlName="Country" class="form-control"
                                                                (keydown)="onlyAlphabates($event)">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="form-control-label">State</label>
                                                            <!-- <select formControlName="State" class="form-control select">
                                                                            <option value="null" [selected]="true">Select State</option>
                                                                            <option *ngFor="let state of stateListArray" [value]="state.text">
                                                                                {{state.text}}
                                                                            </option>
                                                                        </select> -->
                                                            <input formControlName="State" class="form-control"
                                                                (keydown)="onlyAlphabates($event)">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">City</label>
                                                        <div class="form-group">
                                                            <input formControlName="City" class="form-control"
                                                                (keydown)="onlyAlphabates($event)">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Pin Code</label>
                                                        <div class="form-group">
                                                            <input formControlName="PinCode" class="form-control"
                                                                (keydown)="onlyNumber($event)"> </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </section>

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <section class="panel panel-default">
                                        <div class="panel-heading">
                                            <h5 class="panel-title">Office Address</h5>
                                        </div>
                                        <div class="panel-body">
                                            <div formGroupName="OfficeAddress">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Line 1</label>
                                                        <div class="form-group">
                                                            <input formControlName="Line1" class="form-control">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Line 2</label>
                                                        <div class="form-group">
                                                            <input formControlName="Line2" class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Country</label>
                                                        <div class="form-group">
                                                            <input formControlName="Country" class="form-control"
                                                                (keydown)="onlyAlphabates($event)">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">State</label>
                                                        <div class="form-group">
                                                            <input formControlName="State" class="form-control"
                                                                (keydown)="onlyAlphabates($event)">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label class="form-control-label">City</label>
                                                        <div class="form-group">
                                                            <input formControlName="City" class="form-control"
                                                                (keydown)="onlyAlphabates($event)">
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <label class="form-control-label">Pin Code</label>
                                                        <div class="form-group">
                                                            <input formControlName="PinCode" class="form-control"
                                                                (keydown)="onlyNumber($event)">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Telephone Number (O)</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpContactForm.controls['OfficeTelephoneNumber']"
                                            class="form-control" (keydown)="onlyNumber($event)">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Telephone Number (R)</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpContactForm.controls['ResidentTelephoneNumber']"
                                            class="form-control" (keydown)="onlyNumber($event)">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Fax</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpContactForm.controls['Fax']" class="form-control"
                                            pattern="^\+?[0-9]{7,}$">
                                        <div *ngIf="kmpContactForm.controls['Fax'].hasError('pattern') && kmpContactForm.controls['Fax'].touched"
                                            class="form-control-error-custom">
                                            Fax number is not valid.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Mobile Number</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpContactForm.controls['MobileNumber']"
                                            pattern="^\d{10}$" class="form-control" (keydown)="onlyNumber($event)">
                                        <div *ngIf="kmpContactForm.controls['MobileNumber'].hasError('pattern') && kmpContactForm.controls['MobileNumber'].touched"
                                            class="form-control-error-custom">
                                            Mobile Number is not valid.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Aadhaar Number</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpContactForm.controls['AadhaarNumber']"
                                            class="form-control" pattern="^\d{12}$" (onkeypress)="aadharNumber($event)">
                                        <div *ngIf="kmpContactForm.controls['AadhaarNumber'].hasError('pattern')"
                                            class="form-control-error-custom">
                                            Aadhaar Number is not valid.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">New Voter's Identity Card Number</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpContactForm.controls['IdentityNumber']"
                                            class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Passport Number</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpContactForm.controls['PassportNumber']"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Driving License Number</label>
                                    <div class="form-group">
                                        <input [formControl]="kmpContactForm.controls['DrivingLicenseNumber']"
                                            class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade" id="messagePopUp2" tabindex="-1" role="dialog" aria-labelledby=""
                                aria-hidden="true" style="top: 50px;">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div id="alertTitle2" class="modal-header"
                                            style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                            Title!
                                        </div>
                                        <div class="modal-body">
                                            <div id="alertMessage2">
                                                Message..
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade" id="contactConfirmation" tabindex="-1" role="dialog"
                                aria-labelledby="" aria-hidden="true" style="top: 50px;">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="myModalLabelForDelete">
                                                <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    Are you sure you want to clear KMP contact details?
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-sm btn-danger"
                                                (click)="clearContactDetails()">
                                                <i class="fa fa-check"></i>&nbsp;Yes
                                            </button>
                                            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                                                <i class="fa fa-times"></i>&nbsp;No
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="Submit" class="btn-sm btn btn-primary" (click)="contactdetailsInsertUpdate()">
                                <span id="saveUpdateKMPContactDetails"></span>
                            </button>
                            <button type="button" class="btn-sm btn btn-default" (click)="clearkmpContactDetails()">
                                <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                        </div>
                    </form>
                </div>
                <!-- Tab 4 -->
                <div class="tab-pane" id="officeOfKMP" role="tabcard">
                    <div class="modal fade modal-size-large" id="kmpshipDialog" tabindex="-1" role="dialog"
                        aria-labelledby="" aria-hidden="true">
                        <div class="modal-dialog" role="document" (document:click)="doc.close();doa.close();">
                            <div class="modal-content">
                                <form [formGroup]="kmpshipForm" class="well">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="myModalOfficeHeldOrRelinquishedLabel">
                                            <i class="fa fa-plus"></i>&nbsp;Office of KMP held or relinquished in any other
                                            body corporate</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Name of Company</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <div class="form-group">
                                                    <input [formControl]="kmpshipForm.controls['OfficeName']"
                                                        class="form-control" required="required">
                                                    <div *ngIf="kmpshipForm.controls['OfficeName'].hasError('required') && kmpshipForm.controls['OfficeName'].touched"
                                                        class="form-control-error-custom">
                                                        Name of company is required.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Type of Company</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <div class="form-group">
                                                    <select class="form-control"
                                                        [formControl]="kmpshipForm.controls['OfficeType']"
                                                        style="padding:6px;" required="required"
                                                        (change)="setdormantCompany($event);setCIN($event);setOtherCompany($event);setNatureOfIntrest($event);">
                                                        <!-- <option value="" [selected]="true">Select Company Type</option> -->
                                                        <option value="" [selected]="true">Select</option>
                                                        <option *ngFor="let bodycorp of bodycorporateArray"
                                                            [value]="bodycorp.BodyCorporate">
                                                            {{bodycorp.BodyCorporate}}
                                                    </select>
                                                    <div *ngIf="kmpshipForm.controls['OfficeType'].hasError('required') && kmpshipForm.controls['OfficeType'].touched"
                                                        class="form-control-error-custom">
                                                        Please select type of company
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Date of Appointment</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <div class="form-group">
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input class="form-control" [maxDate]="TodayDate"
                                                            [formControl]="kmpshipForm.controls['AppointmentDate']"
                                                            [(ngModel)]="dirAppointmentDateModel" style="padding:6px;"
                                                            placeholder="dd-mm-yyyy" name="AppointmentDate"
                                                            (ngModelChange)="setCessationDateInKMPship($event)"
                                                            required="required" ngbDatepicker #doa="ngbDatepicker"
                                                            (click)="doa.toggle();doc.close();">
                                                        <button class="input-group-addon"
                                                            (click)="doa.toggle();doc.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="kmpshipForm.controls['AppointmentDate'].hasError('required') && kmpshipForm.controls['AppointmentDate'].touched"
                                                        class="form-control-error-custom">
                                                        Appointment Date is required.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Nature Of Interest</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <div class="form-group">
                                                    <select class="form-control"
                                                        [formControl]="kmpshipForm.controls['NatureOfIntrest']"
                                                        style="padding:6px;" required="required"
                                                        (change)="setShareHolding($event);setOtherNatureOfInterest($event);setCommittee($event);">
                                                        <!-- <option value="" [selected]="true">Select Nature Of Interest</option> -->
                                                        <option value="" [selected]="true">Select</option>
                                                        <option *ngFor="let nointrest of natureOfIntrestArray"
                                                            [value]="nointrest.Nature">
                                                            {{nointrest.Nature}}
                                                    </select>
                                                    <div *ngIf="kmpshipForm.controls['NatureOfIntrest'].hasError('required') && kmpshipForm.controls['NatureOfIntrest'].touched"
                                                        class="form-control-error-custom">
                                                        Please select designation
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Date of
                                                    Cessation/relinquishment</label>
                                                <div class="form-group">
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input class="form-control"
                                                            [minDate]="FutureCessationDateInKMPship"
                                                            [formControl]="kmpshipForm.controls['CessationDate']"
                                                            [(ngModel)]="dirCessationDateModel" style="padding:6px;"
                                                            placeholder="dd-mm-yyyy" name="CessationDate" ngbDatepicker
                                                            #doc="ngbDatepicker" disabled="disabled"
                                                            (ngModelChange)="CessationDateIsPriorToAppointmentDate()"
                                                            (click)="doc.toggle();doa.close();">
                                                        <button class="input-group-addon"
                                                            (click)="doc.toggle();doa.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="IsCessationDatePriorInKMPship"
                                                        class="form-control-error-custom">
                                                        Cessation date can not be prior to appointment date
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">PAN of Company</label>
                                                <div class="form-group">
                                                    <input [formControl]="kmpshipForm.controls['PAN']"
                                                        class="form-control upperCase"
                                                        pattern="^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$">
                                                    <div *ngIf="kmpshipForm.controls['PAN'].hasError('pattern') && kmpshipForm.controls['PAN'].touched"
                                                        class="form-control-error-custom">
                                                        PAN is invalid.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6" *ngIf="showShareHolding">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <label class="form-control-label">Shareholding (%)</label>
                                                        <!-- </div>
                                                    <div class="col-md-8"> -->
                                                        <div class="form-group">
                                                            <input [formControl]="kmpshipForm.controls['ShareHolding']"
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="col-md-6">
                                                <label class="form-control-label">Designation</label>
                                                <div class="form-group">
                                                    <select class="form-control" [formControl]="kmpshipForm.controls['Designation']" style="padding:6px;" (change)="setOtherDesignation($event);">
                                                        <option value="null" [selected]="true">Select</option>
                                                        <option *ngFor="let designation of designationArray" [value]="designation.text">
                                                            {{designation.text}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div> -->
                                        </div>
                                        <!-- </div> -->
                                        <div class="row">
                                            <div class="col-md-6" *ngIf="showDormantState">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <label class="form-control-label">Dormant Company</label>
                                                        <div class="form-group">

                                                            <div class="md-radio md-radio-inline">
                                                                <input id="dormantCompanyYes" type="radio"
                                                                    [formControl]="kmpshipForm.controls['DormantCompany']"
                                                                    style="position:absolute" name="DormantCompany"
                                                                    value="true" class="form-check-input">
                                                                <label for="dormantCompanyYes">Yes</label>
                                                            </div>

                                                            <div class="md-radio md-radio-inline">
                                                                <input id="dormantCompanyNo" type="radio"
                                                                    [formControl]="kmpshipForm.controls['DormantCompany']"
                                                                    style="position:absolute" name="DormantCompany"
                                                                    value="false" class="form-check-input">
                                                                <label for="dormantCompanyNo">No</label>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6" *ngIf="showCIN">
                                                <label class="form-control-label">CIN</label>
                                                <div class="form-group">
                                                    <input [formControl]="kmpshipForm.controls['CIN']"
                                                        class="form-control">
                                                    <div *ngIf="kmpshipForm.controls['CIN'].hasError('pattern')"
                                                        class="form-control-error-custom">
                                                        CIN is invalid.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6" *ngIf="showOtherCompany">
                                                <label class="form-control-label">Other Company</label>
                                                <div class="form-group">
                                                    <input [formControl]="kmpshipForm.controls['OtherCompany']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6" *ngIf="showOtherNatureOfInterest">
                                                <label class="form-control-label">Other Nature Of Interest</label>
                                                <div class="form-group">
                                                    <input [formControl]="kmpshipForm.controls['OtherNatureOfInterest']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <!-- </div> -->
                                        <div class="row">
                                            <div class="col-md-6" *ngIf="showOtherDesignation">
                                                <label class="form-control-label">Other Designation</label>
                                                <div class="form-group">
                                                    <input [formControl]="kmpshipForm.controls['OtherDesignation']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6" *ngIf="showCommitee">
                                                <label class="form-control-label">Committee</label>
                                                <div class="form-group">
                                                    <select class="form-control"
                                                        [formControl]="kmpshipForm.controls['CommitteeType']"
                                                        style="padding:6px;" (change)="setOtherCommittee($event);">
                                                        <option value="null">Select Committee</option>
                                                        <option *ngFor="let committee of committeeArray"
                                                            [value]="committee.text">
                                                            {{committee.text}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6" *ngIf="showOtherCommitee">
                                                <label class="form-control-label">Other Committee</label>
                                                <div class="form-group">
                                                    <input [formControl]="kmpshipForm.controls['OtherCommittee']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button id="btnSaveUpdateKmpship" type="Submit" class="btn-sm btn btn-primary"
                                            [disabled]="!kmpshipForm.valid" (click)="kmpshipInsertandUpdate()">
                                            <i class="fa fa-save"></i>

                                        </button>
                                        <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                            <i class="fa fa-times"></i>&nbsp;Close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <section class="card">
                        <div class="card-header">
                            <span class="cat__core__title">
                                Office of KMP held or relinquished in any other body corporate:
                                <div class="pull-right">
                                    <button type="button"
                                        [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                                        class="btn btn-sm btn-primary ml-2" data-toggle="modal"
                                        (click)="clearKmpship();openOfficeHeldOrRelinquishedModal();"
                                        data-target="#kmpshipDialog">
                                        <i class="fa fa-plus"></i>&nbsp;Add</button>
                                </div>
                            </span>
                        </div>
                        <section class="card search-box">
                            <div class="card-block">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <form (document:click)="appDate.close();cesDate.close();">
                                            <div class="row">
                                                <div class="col-lg-2">
                                                    <label class="form-control-label">From Date :
                                                    </label>
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input id="fromDatecalInKMPship"
                                                            [maxDate]="futureFromDateInDisclosure" class="form-control"
                                                            style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                                            name="dpAppointmentInKMPship" ngbDatepicker
                                                            #appDate="ngbDatepicker"
                                                            (click)="appDate.toggle();cesDate.close();"
                                                            (ngModelChange)="setTodateInDisclosure($event)"
                                                            [(ngModel)]="FromDateModelInKMPship">
                                                        <button class="input-group-addon"
                                                            (click)="appDate.toggle();cesDate.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-lg-2">
                                                    <label class="form-control-label">To Date :
                                                    </label>
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input id="toDatecalInKMPship"
                                                            [minDate]="futureToDateInDisclosure" class="form-control"
                                                            style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                                            name="dpCessationInKMPship" ngbDatepicker
                                                            #cesDate="ngbDatepicker"
                                                            (click)="cesDate.toggle();appDate.close();"
                                                            [(ngModel)]="ToDateModelInKMPship"
                                                            (ngModelChange)="setFromdateInDisclosure($event)">
                                                        <button class="input-group-addon"
                                                            (click)="cesDate.toggle();appDate.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <label>&nbsp;&nbsp;&nbsp;</label>
                                                    <div class="input-group">
                                                        <button type="button" [disabled]="response"
                                                            class="btn btn-sm btn-primary mb-2"
                                                            (click)="getKMPshipByParam()">
                                                            <i class="fa fa-search"></i>&nbsp;Search</button>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <button type="button" [disabled]="response"
                                                            class="btn btn-sm btn-default mb-2"
                                                            (click)="getKMPshipByNullParam()">
                                                            <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div class="card-block datatable-card-block">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="margin-bottom-50">
                                        <div class="table-responsive">
                                            <table datatable [dtOptions]="dtOptionsOfKMPship"
                                                [dtTrigger]="dtTriggerKMPship"
                                                class="table table-hover compact cell-border nowrap stripe"
                                                id="kmpshipTable" style="cursor: pointer;">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Type of Company</th>
                                                        <th>Date of Cessation /relinquishment</th>
                                                        <th>Date of Appointment</th>
                                                        <!-- <th>Designation</th> -->
                                                        <th>
                                                            <span
                                                                [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}">Action</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let kmp of kmpshipArray;let i = index">
                                                        <td>
                                                            <label>{{kmp.OfficeName}}</label>
                                                        </td>
                                                        <td>
                                                            <label>{{kmp.OfficeType}}</label>
                                                        </td>


                                                        <td>
                                                            <span style="display: none">
                                                                {{kmp.CessationDate | date : "yMMdd"}}</span>
                                                            <label>{{kmp.CessationDate | date : "dd-MM-y"}}</label>
                                                        </td>

                                                        <td>
                                                            <span style="display: none">
                                                                {{kmp.AppointmentDate | date : "yMMdd"}}</span>
                                                            <label>{{kmp.AppointmentDate | date : "dd-MM-y"}}</label>
                                                        </td>
                                                        <!-- <td>
                                                            <label>{{kmp.Designation}}</label>
                                                        </td> -->
                                                        <td>
                                                            <button class="btn-sm btn btn-warning" type="button"
                                                                [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                                                                data-toggle="modal" data-target="#kmpshipDialog"
                                                                (click)="fetchKmpshipRow(i)">
                                                                <span class="fa fa-pencil"></span>
                                                            </button>
                                                            <button class="btn-sm btn btn-danger" type="button"
                                                                [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                                                                (click)="removeKmpshipConfirmation(kmp._id)">
                                                                <span class="icmn-bin"></span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="modal fade" id="messagePopUp3" tabindex="-1" role="dialog"
                                            aria-labelledby="" aria-hidden="true" style="top: 50px;">
                                            <div class="modal-dialog" role="document">
                                                <div class="modal-content">
                                                    <div id="alertTitle3" class="modal-header"
                                                        style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                                        Title!
                                                    </div>
                                                    <div class="modal-body">
                                                        <div id="alertMessage3">
                                                            Message..
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal fade" id="deletekmpshipconfirmation" tabindex="-1"
                                            role="dialog" aria-labelledby="" aria-hidden="true" style="top: 50px;">
                                            <div class="modal-dialog" role="document">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title" id="myModalLabelForDelete">
                                                            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                                        <button aria-label="Close" class="close" data-dismiss="modal"
                                                            type="button">
                                                            <i class="fa fa-times"></i>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                Are you sure you want to delete the KMPship details?
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-sm btn-danger"
                                                            (click)="removeKmpship()">
                                                            <i class="fa fa-check"></i>&nbsp;Yes
                                                        </button>
                                                        <button type="button" class="btn btn-sm btn-primary"
                                                            data-dismiss="modal">
                                                            <i class="fa fa-times"></i>&nbsp;No
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- </div>
                            </div> -->
                        </div>
                    </section>
                </div>
                <!-- Tab 5 -->
                <div class="tab-pane" id="detailsOfSecurities" role="tabcard">
                    <div class="modal fade modal-size-large" id="subkmpDialog" tabindex="-1" role="dialog"
                        aria-labelledby="" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <form [formGroup]="subKmpForm" class="well"
                                    (document:click)="disp.close();acq.close();">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="myModalSecuritiesDetailsLabel">
                                            <i class="fa fa-plus"></i>&nbsp;Details of securities held in the Company, its
                                            Holding Company, Subsidiaries,
                                            Subsidiaries of the Company's Holding Company and Associate Companies :
                                        </h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Name of Company</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <div class="form-group">
                                                    <input [formControl]="subKmpForm.controls['CompanyName']"
                                                        class="form-control">
                                                    <div *ngIf="subKmpForm.controls['CompanyName'].hasError('required') && subKmpForm.controls['CompanyName'].touched"
                                                        class="form-control-error-custom">
                                                        Company Name is required.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Number of Securities</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <div class="form-group">
                                                    <input [formControl]="subKmpForm.controls['NumberOfSecurities']"
                                                        class="form-control"
                                                        (keydown)="onlyNumberWithoutDecimal($event)"
                                                        [(ngModel)]="NumberOfSecuritiesModel"
                                                        (input)="cumulativeCalculationOnNumberOfSecurities()"
                                                        CommaSeperatedNumber>
                                                    <div *ngIf="subKmpForm.controls['NumberOfSecurities'].hasError('required') && subKmpForm.controls['NumberOfSecurities'].touched"
                                                        class="form-control-error-custom">
                                                        Number of Securities is required.
                                                    </div>
                                                    <div *ngIf="IsNumberOfSecurityLess"
                                                        class="form-control-error-custom">
                                                        <span style="color: red;">
                                                            Number of security can not be less than number of shares
                                                            disposed.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Description of Securities</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <div class="form-group">
                                                    <input [formControl]="subKmpForm.controls['SecurityDescription']"
                                                        class="form-control">
                                                    <div *ngIf="subKmpForm.controls['SecurityDescription'].hasError('required') && subKmpForm.controls['SecurityDescription'].touched"
                                                        class="form-control-error-custom">
                                                        Security Description is required.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Nominal Value of Securities</label>
                                                <div class="form-group">
                                                    <input CommaSeperatedNumber
                                                        [formControl]="subKmpForm.controls['SecurityNominalValue']"
                                                        class="form-control"
                                                        (keydown)="onlyNumberWithoutDecimal($event)">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Date of Acquisition</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <div class="form-group">
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input class="form-control" [maxDate]="TodayDate"
                                                            [formControl]="subKmpForm.controls['AcquisitionDate']"
                                                            [(ngModel)]="AcquisitionDateModel" style="padding:6px;"
                                                            placeholder="dd-mm-yyyy" name="AcquisitionDate"
                                                            ngbDatepicker #acq="ngbDatepicker"
                                                            (click)="acq.toggle();disp.close();"
                                                            (ngModelChange)="setDisposalDateInSubKmp($event)"
                                                            required="required">
                                                        <button class="input-group-addon"
                                                            (click)="acq.toggle();disp.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="subKmpForm.controls['AcquisitionDate'].hasError('required') && subKmpForm.controls['AcquisitionDate'].touched"
                                                        class="form-control-error-custom">
                                                        Please select Acquisition Date
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <label class="form-control-label">Price paid for Acquisition of
                                                    Securities</label>
                                                <div class="form-group">
                                                    <input CommaSeperatedNumber
                                                        [formControl]="subKmpForm.controls['AcquisitionPaidPrize']"
                                                        class="form-control dacimalFix">
                                                    <div *ngIf="subKmpForm.controls['AcquisitionPaidPrize'].hasError('pattern') && subKmpForm.controls['AcquisitionPaidPrize'].touched"
                                                        class="form-control-error-custom">
                                                        Price paid for acquisition of securities is invalid.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Other consideration paid for
                                                    Acquisition</label>
                                                <div class="form-group">
                                                    <input CommaSeperatedNumber
                                                        [formControl]="subKmpForm.controls['AcquisitionOtherPrize']"
                                                        class="form-control dacimalFix">
                                                    <div *ngIf="subKmpForm.controls['AcquisitionOtherPrize'].hasError('pattern') && subKmpForm.controls['AcquisitionOtherPrize'].touched"
                                                        class="form-control-error-custom">
                                                        Other consideration paid for Acquisition is invalid.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <label class="form-control-label">Date of Disposal</label>
                                                <div class="form-group">
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input class="form-control"
                                                            [formControl]="subKmpForm.controls['DisposalDate']"
                                                            [minDate]="FutureDisposalDateInSubKmp"
                                                            [(ngModel)]="DisposalDateModel" style="padding:6px;"
                                                            placeholder="dd-mm-yyyy" name="DisposalDate" ngbDatepicker
                                                            #disp="ngbDatepicker" disabled="disabled"
                                                            (click)="disp.toggle();acq.close();"
                                                            (ngModelChange)="DisposalDateIsPriorToAcquisitionDate()">
                                                        <button class="input-group-addon"
                                                            (click)="disp.toggle();acq.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="IsDisposalDatePriorInSubKmp"
                                                        class="form-control-error-custom">
                                                        Disposal date can not be prior to acquisition date
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Number of shares disposed</label>
                                                <div class="form-group">
                                                    <input CommaSeperatedNumber
                                                        [formControl]="subKmpForm.controls['NumberOfSharesDisposed']"
                                                        class="form-control dacimalFix"
                                                        [(ngModel)]="NumberOfSharesDisposedModel"
                                                        (input)="cumulativeCalculationOnNumberOfShareDisposed()"
                                                        (keydown)="onlyTwoDecimal($event)">
                                                    <div *ngIf="subKmpForm.controls['NumberOfSharesDisposed'].hasError('pattern') && subKmpForm.controls['NumberOfSharesDisposed'].touched"
                                                        class="form-control-error-custom">
                                                        Number of shares disposed is invalid.
                                                    </div>
                                                    <div *ngIf="IsNumberOfSharesLarge"
                                                        class="form-control-error-custom">
                                                        <span style="color: red;">
                                                            Number of shares disposed can not be greater than number of
                                                            securities.
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Price received on Disposal</label>
                                                <div class="form-group">
                                                    <input CommaSeperatedNumber
                                                        [formControl]="subKmpForm.controls['DisposalPrize']"
                                                        class="form-control dacimalFix">
                                                    <div *ngIf="subKmpForm.controls['DisposalPrize'].hasError('pattern') && subKmpForm.controls['DisposalPrize'].touched"
                                                        class="form-control-error-custom">
                                                        Price received on Disposal is invalid.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Other consideration received on
                                                    Disposal</label>
                                                <div class="form-group">
                                                    <input CommaSeperatedNumber
                                                        [formControl]="subKmpForm.controls['DisposalReceivedPrize']"
                                                        class="form-control dacimalFix">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Cumulative balance and number of
                                                    Securities held after each Transaction</label>
                                                <div class="form-group">
                                                    <input CommaSeperatedNumber
                                                        [formControl]="subKmpForm.controls['CumulativePrize']"
                                                        class="form-control" disabled="disabled"
                                                        [(ngModel)]="cumulativeBalanceModel">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Mode of Acquisition of
                                                    Securities</label>
                                                <div class="form-group">
                                                    <input
                                                        [formControl]="subKmpForm.controls['AcquisitionSecuritiesMode']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Mode of holding physical or
                                                    dematerialized form</label>
                                                <div class="form-group">
                                                    <select class="form-control"
                                                        [formControl]="subKmpForm.controls['HoldingMode']"
                                                        class="form-control select">
                                                        <!-- <option value="null" [selected]="true">Selected Mode</option> -->
                                                        <option value="null" [selected]="true">Select</option>
                                                        <option value="Dematerialized" selected="selected">
                                                            Dematerialized</option>
                                                        <option value="Physical" selected="selected">Physical</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Securities pledged or any encumbrance
                                                    created</label>
                                                <div class="form-group">
                                                    <input [formControl]="subKmpForm.controls['PledgedSecurities']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Shareholding (%)</label>
                                                <div class="form-group">
                                                    <input [formControl]="subKmpForm.controls['Shareholding']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button id="btnSaveUpdateSubKMP" type="Submit" class="btn-sm btn btn-primary"
                                            (click)="SubkmpInsertUpdate()"
                                            [disabled]="!subKmpForm.valid || IsNumberOfSharesLarge || IsNumberOfSecurityLess">
                                            <i class="fa fa-save"></i>
                                        </button>
                                        <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                            <i class="fa fa-times"></i>&nbsp;Close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <section class="card">
                        <div class="card-header">
                            <span class="cat__core__title">
                                Details of securities held in the Company, its Holding Company, Subsidiaries,
                                Subsidiaries of the Company's Holding Company
                                and Associate Companies :
                                <div class="pull-right">
                                    <button type="button"
                                        [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                                        class="btn btn-sm btn-primary ml-2" data-toggle="modal"
                                        (click)="clearSubKmp();openAddSubKmpModal();" data-target="#subkmpDialog">
                                        <i class="fa fa-plus"></i>&nbsp;Add</button>
                                </div>
                            </span>
                        </div>
                        <section class="card search-box">
                            <div class="card-block">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <form (document:click)="appsDate.close();cessDate.close();">
                                            <div class="row">
                                                <div class="col-lg-2">
                                                    <label class="form-control-label">From Date :
                                                    </label>
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input id="fromDatecalInSubKMP"
                                                            [maxDate]="futureFromDateInDetailsOfSecurity"
                                                            class="form-control" style="padding:6px;z-index: 0;"
                                                            placeholder="dd-mm-yyyy" name="dpAppointmentInSubKMP"
                                                            ngbDatepicker #appsDate="ngbDatepicker"
                                                            (click)="appsDate.toggle();cessDate.close();"
                                                            (ngModelChange)="setTodateInDetailsOfSecurity($event)"
                                                            [(ngModel)]="FromDateModelInSubKMP">
                                                        <button class="input-group-addon"
                                                            (click)="appsDate.toggle();cessDate.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-lg-2">
                                                    <label class="form-control-label">To Date :
                                                    </label>
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input id="toDatecalInSubKMP"
                                                            [minDate]="futureToDateInDetailsOfSecurity"
                                                            class="form-control" style="padding:6px;z-index: 0;"
                                                            placeholder="dd-mm-yyyy" name="dpCessationInSubKMP"
                                                            ngbDatepicker #cessDate="ngbDatepicker"
                                                            (click)="cessDate.toggle();appsDate.close();"
                                                            (ngModelChange)="setFromdateInDetailsOfSecurity($event)"
                                                            [(ngModel)]="ToDateModelInSubKMP">
                                                        <button class="input-group-addon"
                                                            (click)="cessDate.toggle();appsDate.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <label>&nbsp;&nbsp;&nbsp;</label>
                                                    <div class="input-group">
                                                        <button type="button" [disabled]="response"
                                                            class="btn btn-sm btn-primary mb-2"
                                                            (click)="getSubKMPByParam()">
                                                            <i class="fa fa-search"></i>&nbsp;Search</button>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <button type="button" [disabled]="response"
                                                            class="btn btn-sm btn-default mb-2"
                                                            (click)="getSubKMPByNullParam()">
                                                            <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div class="card-block datatable-card-block">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="margin-bottom-50">
                                        <div class="table-responsive">
                                            <table datatable [dtOptions]="dtOptionsOfSubKMP"
                                                [dtTrigger]="dtTriggerSubKMP"
                                                class="table table-hover compact cell-border nowrap stripe"
                                                id="subKmpTable" style="cursor: pointer;">
                                                <thead>
                                                    <tr>
                                                        <th >Name of the Company</th>
                                                        <th>Description of Securities</th>
                                                        <th >Date of disposal</th>
                                                        <th >Date of Acquisition</th>
                                                        <th >Number of shares disposed</th>
                                                        <th >
                                                            <span
                                                                [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}">Action</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let subkmp of subkmpArray let i = index">
                                                        <td>
                                                            <label>{{subkmp.CompanyName}}</label>
                                                        </td>
                                                        <td>
                                                            <label>{{subkmp.SecurityDescription}}</label>
                                                        </td>

                                                        <td>
                                                            <span style="display: none">
                                                                {{subkmp.DisposalDate | date : "yMMdd"}}</span>
                                                            <label>{{subkmp.DisposalDate | date : "dd-MM-y"}}</label>
                                                        </td>
                                                        <td>
                                                            <span style="display: none">
                                                                {{subkmp.AcquisitionDate | date : "yMMdd"}}</span>
                                                            <label>{{subkmp.AcquisitionDate | date : "dd-MM-y"}}</label>
                                                        </td>
                                                        <td>
                                                            <label>{{subkmp.NumberOfSharesDisposed}}</label>
                                                        </td>
                                                        <td>
                                                            <button class="btn-sm btn btn-warning" type="button"
                                                                [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                                                                (click)="fetchSubKmpRow(i)" data-toggle="modal"
                                                                data-target="#subkmpDialog">
                                                                <span class="fa fa-pencil"></span>
                                                            </button>
                                                            <button class="btn-sm btn btn-danger" type="button"
                                                                [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                                                                (click)="removeSubKmpConfirmation(subkmp._id)">
                                                                <span class="icmn-bin"></span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="modal fade" id="messagePopUp4" tabindex="-1" role="dialog"
                                            aria-labelledby="" aria-hidden="true" style="top: 50px;">
                                            <div class="modal-dialog" role="document">
                                                <div class="modal-content">
                                                    <div id="alertTitle4" class="modal-header"
                                                        style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                                        Title!
                                                    </div>
                                                    <div class="modal-body">
                                                        <div id="alertMessage4">
                                                            Message..
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal fade" id="deletesubKmpconfirmation" tabindex="-1"
                                            role="dialog" aria-labelledby="" aria-hidden="true" style="top: 50px;">
                                            <div class="modal-dialog" role="document">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title" id="myModalLabelForDelete">
                                                            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                                        <button aria-label="Close" class="close" data-dismiss="modal"
                                                            type="button">
                                                            <i class="fa fa-times"></i>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                Are you sure you want to delete the Sub KMP details?
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-sm btn-danger"
                                                            (click)="RemoveSubKmp()">
                                                            <i class="fa fa-check"></i>&nbsp;Yes
                                                        </button>
                                                        <button type="button" class="btn btn-sm btn-primary"
                                                            data-dismiss="modal">
                                                            <i class="fa fa-times"></i>&nbsp;No
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <!-- </div> -->

                <!-- Tab 6 -->
                <div class="tab-pane" id="relativedetails" role="tabcard">


                    <div class="modal fade modal-size-large" id="relativeDialog" tabindex="-1" role="dialog"
                        aria-labelledby="" aria-hidden="true">
                        <div class="modal-dialog" role="document" (document:click)="id.close();ic.close();">
                            <div class="modal-content">
                                <form [formGroup]="relativeForm" class="well">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="myModalRelativeDetailsLabel">
                                            <i class="fa fa-plus"></i>Relatives' Details</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Name of Relative</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <!-- </div>
                                            <div class="col-md-4"> -->
                                                <div class="form-group">
                                                    <input [formControl]="relativeForm.controls['RelativeName']"
                                                        class="form-control" required="required"
                                                        (keydown)="onlyAlphabates($event)">
                                                    <div *ngIf="relativeForm.controls['RelativeName'].hasError('required') && relativeForm.controls['RelativeName'].touched"
                                                        class="form-control-error-custom">
                                                        Please enter relative name.
                                                    </div>
                                                    <div *ngIf="relativeForm.controls['RelativeName'].hasError('pattern') && relativeForm.controls['RelativeName'].touched"
                                                        class="form-control-error-custom">
                                                        Relative name is invalid.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Relationship</label>
                                                <span _ngcontent-c2="" style="color: red;">*</span>
                                                <!-- </div>
                                            <div class="col-md-4"> -->
                                                <div class="form-group">
                                                    <select class="form-control"
                                                        [formControl]="relativeForm.controls['Relationship']"
                                                        style="padding:6px;" required="required">
                                                        <option value="" [selected]="true">Select</option>
                                                        <!-- <option value="" [selected]="true">Select Relationship</option> -->
                                                        <option *ngFor="let relation of relationArray"
                                                            [value]="relation.text">
                                                            {{relation.text}}
                                                    </select>
                                                    <div *ngIf="relativeForm.controls['Relationship'].hasError('required') && relativeForm.controls['Relationship'].touched"
                                                        class="form-control-error-custom">
                                                        Please select relationship
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Relative PAN</label>
                                                <!-- </div>
                                            <div class="col-md-4"> -->
                                                <div class="form-group">
                                                    <input [formControl]="relativeForm.controls['RelativePAN']"
                                                        class="form-control upperCase"
                                                        pattern="^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$">
                                                    <div *ngIf="relativeForm.controls['RelativePAN'].hasError('pattern') && relativeForm.controls['RelativePAN'].touched"
                                                        class="form-control-error-custom">
                                                        PAN is invalid.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Name of the Company / Body Corporate /
                                                    Firm / Association of Individuals
                                                </label>
                                                <!-- </div>
                                            <div class="col-md-4"> -->
                                                <div class="form-group">
                                                    <input [formControl]="relativeForm.controls['FirmName']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">PAN of Company / Firm / Association of
                                                    Individuals</label>
                                                <!-- </div>
                                            <div class="col-md-4"> -->
                                                <div class="form-group">
                                                    <input [formControl]="relativeForm.controls['CompanyPAN']"
                                                        class="form-control upperCase"
                                                        pattern="^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$">
                                                    <div *ngIf="relativeForm.controls['CompanyPAN'].hasError('pattern') && relativeForm.controls['CompanyPAN'].touched"
                                                        class="form-control-error-custom">
                                                        PAN is invalid.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Type of Company / Body Corporate /
                                                    Firm / Association of Individuals</label>
                                                <!-- </div>
                                            <div class="col-md-4"> -->
                                                <div class="form-group">
                                                    <select class="form-control"
                                                        [formControl]="relativeForm.controls['FirmType']"
                                                        style="padding:6px;"
                                                        (change)="setdormantCompanyRelative($event);setCINRelative($event);setOtherCompanyInRelative($event);setNatureOfIntrest($event);">
                                                        <!-- <option value="null" [selected]="true">Select Company Type</option> -->
                                                        <option value="null" [selected]="true">Select</option>
                                                        <option *ngFor="let bodycorp of bodycorporateArray"
                                                            [value]="bodycorp.BodyCorporate">
                                                            {{bodycorp.BodyCorporate}}
                                                    </select>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Nature of interest or concern</label>
                                                <!-- </div>
                                            <div class="col-md-4"> -->
                                                <div class="form-group">
                                                    <select class="form-control"
                                                        [formControl]="relativeForm.controls['NatureOfIntrest']"
                                                        style="padding:6px;"
                                                        (change)="showShareholdingForRelative($event);otherNatureOfIntrestInRelative($event);setCommitteeRelative($event);">
                                                        <!-- <option value="null" [selected]="true">Select nature of interest</option> -->
                                                        <option value="null" [selected]="true">Select</option>
                                                        <option *ngFor="let nointrest of natureOfIntrestArray"
                                                            [value]="nointrest.Nature">
                                                            {{nointrest.Nature}}
                                                    </select>

                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Date on which interest or concern
                                                    arose</label>
                                                <!-- </div>
                                            <div class="col-md-4"> -->
                                                <div class="form-group">
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input class="form-control" [maxDate]="TodayDate"
                                                            [formControl]="relativeForm.controls['IntrestDate']"
                                                            [(ngModel)]="IntrestDateModel" style="padding:6px;"
                                                            placeholder="dd-mm-yyyy" name="IntrestDate" ngbDatepicker
                                                            #id="ngbDatepicker"
                                                            (ngModelChange)="setIntrestChangeDateInRelative($event)"
                                                            (click)="id.toggle();ic.close();">
                                                        <button class="input-group-addon"
                                                            (click)="id.toggle();ic.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-control-label">Change in interest or concern</label>
                                                <div class="form-group">
                                                    <input [formControl]="relativeForm.controls['IntrestChange']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-control-label">Date on which interest or concern
                                                    changed</label>
                                                <div class="form-group">
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input class="form-control" [minDate]="FutureIntrestChangeDate"
                                                            [maxDate]="TodayDate"
                                                            [formControl]="relativeForm.controls['IntrestChangeDate']"
                                                            [(ngModel)]="IntrestChangeDateModel" style="padding:6px;"
                                                            placeholder="dd-mm-yyyy" name="IntrestChangeDate"
                                                            (ngModelChange)="InterestChangeDateIsPriorToInterestDate()"
                                                            ngbDatepicker #ic="ngbDatepicker"
                                                            (click)="ic.toggle();id.close();" disabled="disabled">
                                                        <button class="input-group-addon"
                                                            (click)="ic.toggle();id.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="IsInterestChangeDatePriorInRelative"
                                                        class="form-control-error-custom">
                                                        Interest change date can not be prior to Interest date
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6" *ngIf="showShareholdingInRelative">
                                                <label class="form-control-label">Shareholding (%)</label>
                                                <div class="form-group">
                                                    <input [formControl]="relativeForm.controls['Shareholding']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-6" *ngIf="showOtherCompanyForRelative">
                                                <label class="form-control-label">Other Company</label>
                                                <div class="form-group">
                                                    <input
                                                        [formControl]="relativeForm.controls['OtherCompanyForRelative']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6" *ngIf="showCommiteeRelative">
                                                <label class="form-control-label">Committee</label>
                                                <div class="form-group">
                                                    <select class="form-control"
                                                        [formControl]="relativeForm.controls['CommitteeType']"
                                                        style="padding:6px;"
                                                        (change)="setOtherCommitteeRelative($event);">
                                                        <option value="null">Select Committee</option>
                                                        <option *ngFor="let committee of committeeArray"
                                                            [value]="committee.text">
                                                            {{committee.text}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6" *ngIf="showOtherCommiteeRelative">
                                                <label class="form-control-label">Other Committee</label>
                                                <div class="form-group">
                                                    <input [formControl]="relativeForm.controls['OtherCommittee']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6" *ngIf="showOtherNatureForRelative">
                                                <label class="form-control-label">Other nature</label>
                                                <div class="form-group">
                                                    <input
                                                        [formControl]="relativeForm.controls['OtherNatureOfIntrestForRelative']"
                                                        class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6" *ngIf="showDormantStateRelative">
                                                <label class="form-control-label">Dormant Company</label>
                                                <div class="form-group">
                                                    <div class="md-radio md-radio-inline">
                                                        <input id="dormantCompanyYes" type="radio"
                                                            [formControl]="relativeForm.controls['DormantCompany']"
                                                            style="position:absolute" name="DormantCompany" value="true"
                                                            class="form-check-input">
                                                        <label for="dormantCompanyYes">Yes</label>
                                                    </div>
                                                    <div class="md-radio md-radio-inline">
                                                        <input id="dormantCompanyNo" type="radio"
                                                            [formControl]="relativeForm.controls['DormantCompany']"
                                                            style="position:absolute" name="DormantCompany"
                                                            value="false" class="form-check-input">
                                                        <label for="dormantCompanyNo">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="showCINRelative" class="col-md-6">

                                                <label class="form-control-label">CIN</label>
                                                <div class="form-group">
                                                    <input [formControl]="relativeForm.controls['CIN']"
                                                        class="form-control upperCase"
                                                        pattern="^([a-zA-Z]){1}([0-9]){5}([a-zA-Z]){2}([0-9]){4}([a-zA-Z]){3}([0-9]){6}?$">
                                                    <div *ngIf="relativeForm.controls['CIN'].hasError('pattern')"
                                                        class="form-control-error-custom">
                                                        CIN is invalid.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal-footer">
                                        <button id="btnSaveUpdateRelative" type="Submit" class="btn-sm btn btn-primary"
                                            (click)="InsertAndUpdateRelatives()" [disabled]="!relativeForm.valid">
                                            <i class="fa fa-save"></i>
                                        </button>
                                        <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                            <i class="fa fa-times"></i>&nbsp;Close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <section class="card">
                        <div class="card-header">
                            <span class="cat__core__title">
                                Relatives' Details
                                <div class="pull-right">
                                    <button type="button"
                                        [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                                        class="btn btn-sm btn-primary ml-2" data-toggle="modal"
                                        (click)="clearRelatives();openAddRelativeModal();"
                                        data-target="#relativeDialog">
                                        <i class="fa fa-plus"></i>&nbsp;Add</button>
                                </div>
                            </span>
                        </div>
                        <section class="card search-box">
                            <div class="card-block">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <form (document:click)="apprDate.close();cesrDate.close();">
                                            <div class="row">
                                                <div class="col-lg-2">
                                                    <label class="form-control-label">From Date :
                                                    </label>
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input id="fromDatecalInRelative"
                                                            [maxDate]="futureFromDateInRelative" class="form-control"
                                                            style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                                            name="dpAppointmentInRelative" ngbDatepicker
                                                            #apprDate="ngbDatepicker"
                                                            (click)="apprDate.toggle();cesrDate.close();"
                                                            (ngModelChange)="setTodateInRelative($event)"
                                                            [(ngModel)]="FromDateModelInRelative">
                                                        <button class="input-group-addon"
                                                            (click)="apprDate.toggle();cesrDate.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-lg-2">
                                                    <label class="form-control-label">To Date :
                                                    </label>
                                                    <div class="input-group" (click)="$event.stopPropagation()">
                                                        <input id="toDatecalInSubKMP" [minDate]="futureToDateInRelative"
                                                            class="form-control" style="padding:6px;z-index: 0;"
                                                            placeholder="dd-mm-yyyy" name="dpCessationInRelative"
                                                            ngbDatepicker #cesrDate="ngbDatepicker"
                                                            (click)="cesrDate.toggle();apprDate.close();"
                                                            (ngModelChange)="setFromdateInRelative($event)"
                                                            [(ngModel)]="ToDateModelInRelative">
                                                        <button class="input-group-addon"
                                                            (click)="cesrDate.toggle();apprDate.close();" type="button">
                                                            <span class="fa fa-calendar"
                                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <label>&nbsp;&nbsp;&nbsp;</label>
                                                    <div class="input-group">
                                                        <button type="button" [disabled]="response"
                                                            class="btn btn-sm btn-primary mb-2"
                                                            (click)="getRelativeByParam()">
                                                            <i class="fa fa-search"></i>&nbsp;Search</button>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <button type="button" [disabled]="response"
                                                            class="btn btn-sm btn-default mb-2"
                                                            (click)="getRelativeByNullParam()">
                                                            <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div class="card-block datatable-card-block">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="margin-bottom-50">
                                        <div class="table-responsive">
                                            <table datatable [dtOptions]="dtOptionsOfRelative"
                                                [dtTrigger]="dtTriggerRelative"
                                                class="table table-hover compact cell-border nowrap stripe"
                                                id="relationTable" style="cursor: pointer;">
                                                <thead>
                                                    <tr>
                                                        <th>Name of the Relative</th>
                                                        <th>Relationship</th>
                                                        <th>
                                                            <span
                                                                [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}">Action</span>
                                                        </th>>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let relative of relativesArray let i = index">
                                                        <td>
                                                            <label>{{relative.RelativeName}}</label>
                                                        </td>
                                                        <td>
                                                            <label>{{relative.Relationship}}</label>
                                                        </td>
                                                        <td>
                                                            <!-- data-toggle="modal" data-target="#relativeDialog" -->
                                                            <button class="btn-sm btn btn-warning" type="button"
                                                                [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                                                                (click)="fetchRelatives(i)">
                                                                <span class="fa fa-pencil"></span>
                                                            </button>
                                                            <button class="btn-sm btn btn-danger" type="button"
                                                                [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}"
                                                                (click)="removeRelativeConfirmation(relative._id)">
                                                                <span class="icmn-bin"></span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="modal fade" id="messagePopUp5" tabindex="-1" role="dialog"
                                        aria-labelledby="" aria-hidden="true" style="top: 50px;">
                                        <div class="modal-dialog" role="document">
                                            <div class="modal-content">
                                                <div id="alertTitle5" class="modal-header"
                                                    style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                                    Title!
                                                </div>
                                                <div class="modal-body">
                                                    <div id="alertMessage5">
                                                        Message..
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal fade" id="deleterelativeconfirmation" tabindex="-1" role="dialog"
                                        aria-labelledby="" aria-hidden="true" style="top: 50px;">
                                        <div class="modal-dialog" role="document">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title" id="myModalLabelForDelete">
                                                        <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                                    <button aria-label="Close" class="close" data-dismiss="modal"
                                                        type="button">
                                                        <i class="fa fa-times"></i>
                                                    </button>
                                                </div>
                                                <div class="modal-body">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            Are you sure you want to delete the Relative details?
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeRelatives()">
                                                        <i class="fa fa-check"></i>&nbsp;Yes
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-primary"
                                                        data-dismiss="modal">
                                                        <i class="fa fa-times"></i>&nbsp;No
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</section>